import { Navigation } from '@/components/layout/Navigation';
import { Section } from '@/components/ui/layouts/sections/Section';
import { Instances } from '../Instances';

import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { DetailSection } from '@/components/ui/layouts/sections/DetailSection';
import { GoToCta } from '@/components/ui/navigation/ctas/GoToCta';
import { useContext } from 'react';

export const LanguageCourseDetail = ({ data, isRelation, ...props }) => {
  const hasTitle = !!data?.fields?.title;
  const blocks = data?.relations?.LanguageCourseDetailBlocks || [];
  const { st } = useContext(StaticTextContext);
  const instances = blocks.map((block, idx) => ({
    ...block,
    _isRelationTitle: hasTitle ? true : idx !== 0,
  }));
  const SectionTag = isRelation ? DetailSection : Section;
  return (
    <SectionTag
      heading={{
        title: data?.fields?.title,
        intro: data?.fields?.description,
      }}
      id={data?.fields?.id}
      {...(!isRelation && { footer: <GoToCta text={st('body.goto')} /> })}
      {...props}
    >
      <Navigation
        instances={data?.relations?.InnerSectionNavigations || []}
        variant={'secondary'}
        isRelation={data?.meta?.has_relations}
      />
      <Instances
        instances={instances}
        isRelation={data?.meta?.has_relations}
        sectionId={data?.fields?.id}
      />
    </SectionTag>
  );
};
